/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/4/2022.
 */

import React from 'react'
import {withRouter} from 'react-router'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import * as FaultActions from '../FaultActions'
import * as SecurityActions from '../../security/SecurityActions'
import {injectIntl} from 'react-intl';
import {Select, Table, Icon} from '@scuf/common';
import {ACTION_TYPES, CORRECTIVE_ACTION_STATE} from "../common/FaultsConst";
import {EXISTING_ACTION_ID, NEW_ACTION_ID} from "../common/FaultsUtils";
import ActionDetail from "./ActionDetail";
import Progress from "../../common/Progress";

class ActionRow extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            result: this.props.action.currentResult && this.props.action.type === ACTION_TYPES.TEST ? parseInt(this.props.action.currentResult, 10) : (this.props.action.currentResult === null ? 0 : this.props.action.currentResult),
            testResults: [],
        }

        this.timeout = 5;
    }

    getRowClass(className, index, theme) {
        return className + ' ' + (index % 2 === 0 ? 'even' : 'odd') + (theme === 'dark' ? '-dark' : '')
    }

    getStateOptions(action) {
        const {intl} = this.props
        if (action.type === ACTION_TYPES.TEST) {
            let stateOptions = [{
                value: 0,
                text: intl.formatMessage({id: 'fault.troubleshoot.test.result.not_performed'}),
                learningLoopTestResult: false,
            }];

            const testResults = action.id === EXISTING_ACTION_ID ? this.state.testResults : action.testResults;

            return stateOptions.concat(
                testResults.map(testR => {
                    return {value: testR.id, text: testR.name, learningLoopTestResult: testR.learningLoopTestResult}
                }).sort((a, b) => a.value - b.value)
            )
        }

        const stateOptions = [];
        for (const key in CORRECTIVE_ACTION_STATE) {
            if (CORRECTIVE_ACTION_STATE.hasOwnProperty(key)) {
                stateOptions.push({
                    value: CORRECTIVE_ACTION_STATE[key],
                    text: intl.formatMessage({id: 'fault.troubleshoot.ca.state.' + CORRECTIVE_ACTION_STATE[key]}),
                });
            }
        }

        return stateOptions.sort(orderOptions);
    }

    delayProcessingOnClick() {
        clearTimeout(this.timeout)
    }

    setResult(buttonData, oldValue) {
        if (buttonData.value !== oldValue) {
            this.setState({result: buttonData.value})
            this.submitActionResult(buttonData);
        }
    }

    getOriginalActionResult() {
        return this.props.action.currentResult && this.props.action.type === ACTION_TYPES.TEST ?
            parseInt(this.props.action.currentResult, 10) : this.props.action.currentResult
    }

    submitActionResult(buttonData) {
        const me = this;
        clearTimeout(this.timeout)
        // do not store value that is already set (this prevents from throwing business exception and logging out)
        if (buttonData.value !== this.getOriginalActionResult()) {
            this.timeout = setTimeout(function () {
                    me.props.onResultSelected(me.props.action, buttonData);
                }, 1500
            )
        }
    }

    toggleResultButton(buttonData) {
        if (this.props.action.type === ACTION_TYPES.CORRECTIVE_ACTION && buttonData.value === CORRECTIVE_ACTION_STATE.FIXED) {
            this.props.setLoading()
        }
        this.delayProcessingOnClick(buttonData.value)
        this.setResult(buttonData, this.state.result)
    }

    getResultButtonGroup(action, disabled) {
        const {intl} = this.props
        const resultButtonData = this.getStateOptions(action)

        return (
            <Select className="result-select"
                    options={resultButtonData}
                    onChange={(idk) => this.toggleResultButton(resultButtonData.find(x => x.value === idk))}
                    value={action.type === ACTION_TYPES.TEST ? parseInt(this.state.result, 10) : this.state.result}
                    placeholder={intl.formatMessage({id: 'fault.troubleshoot.test.result.not_performed'})}
            />
        )
    }

    render() {
        const { action, doneRowsIds, actionIndex, disabled, expandedRows } = this.props;
        const rowKey = action.type + '-' + action.id
        const isTest = action.type === ACTION_TYPES.TEST;

        // Filter options for the select component, discard those that are already present
        let allOptions = null
        if (action.id === EXISTING_ACTION_ID) {
            allOptions = (isTest ? this.state.allTestNames : this.state.allCasNames)
                .filter(a => !doneRowsIds.includes(a.id))
                .map((a, i) => {
                    return {value: i, text: a.name, id: a.id}
                })
        }

        let expandedRow = null;
        if (expandedRows.indexOf(rowKey) >= 0) {
            expandedRow = (
                <Table.Row className={this.getRowClass("clickable-row", actionIndex, 'dark')}>
                    <Table.Cell colSpan={5}>
                        <ActionDetail
                            selectedOption={this.props.selectedOption}
                            options={allOptions}
                            onSelectorChange={this.props.onSelectorChange}
                            showCauses={this.props.showCauses} action={action}
                            nextStep={this.props.nextStep}
                            onResultSelected={this.props.onResultSelected} disabled={disabled}
                            notExistingComment={this.props.notExistingComment}
                            setNotExistingName={this.props.setNotExistingName}
                            onButtonClick={this.props.onButtonClick}
                            fetchNewData={this.props.fetchNewData}
                            fetchNewOptions={this.props.fetchNewOptions}
                        />
                    </Table.Cell>
                </Table.Row>
            )
        }

        return (
            <React.Fragment key={rowKey}>
                <Table.Row className={this.getRowClass("extra-row mobile only", actionIndex, 'dark')} onClick={() => this.props.toggleRow(rowKey)}>
                    <Table.Cell colSpan={5}>
                        {action.name}
                    </Table.Cell>
                </Table.Row>
                <Table.Row className={this.getRowClass("clickable-row", actionIndex, 'dark')} onClick={() => this.props.toggleRow(rowKey)}>
                    {isTest ?
                        <Table.Cell className={"test-cell".concat((action.learningLoopTable || action.id === EXISTING_ACTION_ID || action.id === NEW_ACTION_ID)? " custom-icon-background" : "")}>
                            <Icon root='common' name='clipboard' size='large' />
                        </Table.Cell>
                        :
                        <Table.Cell className={"ca-cell".concat(action.learningLoopTable ? " custom-icon-background" : "")}>
                            <Icon name='tools' size="large"/>
                        </Table.Cell>
                    }
                    {isTest && (action.id !== 'NEW' && action.id !== "EXISTING") &&
                        <Table.Cell className={isTest ? "computer only" : ""}>
                            <Progress value={action.benefit}/>
                        </Table.Cell>
                    }
                    {!isTest && (action.id !== 'NEW' && action.id !== "EXISTING") &&
                        <Table.Cell>
                            <Progress value={action.likelihood} disabled={action.likelihood < 0} color="red" />
                        </Table.Cell>
                    }
                    <Table.Cell className="computer only">
                        {action.name}
                    </Table.Cell>
                    <Table.Cell>
                        {this.getResultButtonGroup(action, disabled)}
                    </Table.Cell>
                    <Table.Cell textAlign="center" className="computer only">
                        <div className="expand-icon"><Icon name={expandedRow ? 'caret-up' : 'caret-down'}
                                                           size="medium"/></div>
                    </Table.Cell>
                    <Table.Cell textAlign="right" className="mobile only">
                        <div className="expand-icon"><Icon name={expandedRow ? 'caret-up' : 'caret-down'}
                                                           size="medium"/></div>
                    </Table.Cell>
                </Table.Row>
                {expandedRow}
            </React.Fragment>
        )
    }
}

const orderOptions = (a, b) => {
    if (a.value > b.value) {
        return -1
    }
    if (a.value < b.value) {
        return 1
    }
    return 0;
}

const mapStateToProps = (state) => {
    return {
        fault: state.fault,
        userProfile: state.security.userProfile,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        FaultActions: bindActionCreators(FaultActions, dispatch),
        SecurityActions: bindActionCreators(SecurityActions, dispatch),
    }
}


export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(ActionRow)))